<div class="modal-header py-2 bg-dark text-light">
  <h4 class="modal-title">
    <i class="mdi mdi-email-outline"></i>
    알 림
  </h4>
</div>

<div class="modal-body">
  <div class="w-100" style="height: 200px;">{{Context}}</div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary btn-sm"
          (click)="clickCancel()">
    <i class="mdi mdi-close"></i>
    닫 기
  </button>
</div>
